const disableButton = (element) => {
    if (!(element instanceof jQuery)) element = $(element);

    element.addClass('button-disabled');
    element.css('pointer-events', 'none');
}

const enableButton = (element) => {
    if (!(element instanceof jQuery)) element = $(element);

    element.removeClass('button-disabled');
    element.css('pointer-events', 'auto');
}

const executeOnReady = (callback) => {
    if (document.readyState === 'complete') {
        callback();
    } else {
        window.addEventListener('load', callback);
    }
}

const loginRegisterModalShown = () => {
    return $("#modal-login").hasClass("show") || $('#new-password-modal').hasClass('show')
        || $('#forgot-password-modal').hasClass('show') || $('#playfina-signup-popup').hasClass('show')
}

const openLoginModal = (redirectLink = '') => {
    let modal = $('#modal-signup');
    modal.attr('data-redirect-link', redirectLink);
    modal.removeClass('modal-signup-second');
    modal.removeClass('modal-password');
    modal.addClass('modal-login');
};

const gameOpenLoginModal = (e) => {
    e = e || window.event;
    let target = e.target || e.srcElement || e;
    if (target.nodeType == 3) target = target.parentNode; // defeat Safari bug
    let element = $(target);
    let url = element.attr('data-game-url') ?? element.attr('href') ?? '';
    if (typeof window.isLoginRegisterModalOpen != 'function' || !window.isLoginRegisterModalOpen())
        openLoginModal(url);
    return false;
};

const refreshCsfrToken = async () => {
    const rawResponse = await fetch('/csrf/get-new', {
        credentials: 'include',
    });
    const response = await rawResponse.json();
    const key = Object.keys(response)[0];
    const value = response[key];
    $('meta[name="csrf-token"]').attr('content', value);
};

(() => {
    window.isLoginRegisterModalOpen = loginRegisterModalShown;
})();